module.exports = __webpack_public_path__ + "assets/343be644d67bda27cf5f404fd9e62c7e.mp3";